import {BrickContext, ActionBrick, registerBrick, CloudObject} from 'olympe';
import {format} from "date-fns";

export default class TransformOrdersToMarkLines extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} orders
     * @param {function()} forwardEvent
     * @param {function(Array)} setMarkLines
     */
    update($, [orders], [forwardEvent, setMarkLines]) {
        setMarkLines(orders.map(order => {
            if (order instanceof CloudObject) {
                order = order.toJSON();
            }

            if (order.close) {
                const open = new Date(order.open);
                const close = new Date(order.close);
                console.log(open, close);
                const entryPoint = {
                    coord: [format(open, 'dd.MM.yyyy HH:mm'), order.priceOpen],
                    lineStyle: {color: order.gain > 0 ? '#00FF00' : '#FF0000'}
                }
                const closePoint = {
                    coord: [format(close, 'dd.MM.yyyy HH:mm'), order.priceClose],
                    lineStyle: {color: order.gain > 0 ? '#00FF00' : '#FF0000'}
                }

                return [entryPoint, closePoint];
            } else {
                return null;
            }
        }).filter(Boolean));
        forwardEvent();
    }
}

registerBrick('0194ea600b59fda36f4f', TransformOrdersToMarkLines);
